import plane from '../../images/Plane.png';
const States = () => {
    return(
        <>
            <div className=''>
                <div className=" 
                xl:grid xl:grid-cols-[45%_45%] xl:gap-[10%]
                lg:grid lg:grid-cols-[45%_45%] lg:gap-[10%]
                md:flex md:flex-col 
                sm:flex sm:flex-col">
                <div className='flex flex-col xl:gap-14 lg:gap-10 md:gap-8 sm:gap-7'>
                    <div className="">
                    <h2 className="uppercase font-medium w-full
                xl:text-4xl xl:pb-12
                lg:text-4xl lg:pb-12
                md:text-3xl md:pb-10
                sm:text-[28px] sm:pb-4 ">Габариты, вес и питание</h2>
                        <h3 className="xl:pb-5 lg:pb-4 md:pb-3 sm:pb-3 font-bold text-3xl">Питание</h3>
                        <p>При выборе блока питания для устройства важно обратить внимание на несколько ключевых параметров. В первую очередь, убедитесь, что вы выбираете блок питания с правильным напряжением и током, подходящим для вашего устройства. Также обратите внимание на мощность блока питания - она должна быть достаточной для нормального функционирования устройства.</p>
                    </div>
                    <div className="">
                        <h3 className="xl:pb-5 lg:pb-4 md:pb-3 sm:pb-3  font-bold text-3xl">Вес</h3>
                        <p>При выборе блока питания для устройства важно обратить внимание на несколько ключевых параметров. В первую очередь, убедитесь, что вы выбираете блок питания с правильным напряжением и током, подходящим для вашего устройства. </p>
                    </div>
                    <div className="">
                        <h3 className="xl:pb-5 lg:pb-4 md:pb-3 sm:pb-3  font-bold text-3xl">Габаритры</h3>
                        <div className='flex justify-between'>
                            <div>
                                <p>Высота:</p>
                                <p>Высота:</p>
                                <p>Высота:</p>
                            </div>
                            <div>
                                <p>250 см</p>
                                <p>300 см</p>
                                <p>180 см</p>
                            </div>
                        </div>
                    </div>
                </div>
                    
                    <img src={plane} alt="plane"/>
                </div>
            </div>
        </>
    )
}
export default States;